import { v4 as uuidv4 } from "uuid";

import { EndpointType } from "../../constants/Endpoints";
import { ResultFile } from "../../hooks/useFile";
import { OacJsonResponse } from "../../types/demo";
import { ExtractorOacJsonResponse } from "../../types/extractorOacResponse";
import { LAOacJsonResponse } from "../../types/laOacResponse";
import { OCROacJsonResponse } from "../../types/ocrOacResponse";
import {
  processExtractorResult,
  processLAResult,
  processOCRResult,
} from "../../utils/resultProcessor";

// 처리된 결과 가져오기 (빈 값 채우기, 리사이즈 등)
export const getProcessedResult = async (
  result: OacJsonResponse,
  endpointType: EndpointType,
): Promise<OacJsonResponse> => {
  const hasValidMetadata =
    result.metadata?.pages?.length > 0 && result.metadata.pages[0].height > 0;

  switch (endpointType) {
    case "extractor":
      return await processExtractorResult(
        result as ExtractorOacJsonResponse,
        hasValidMetadata,
      );
    case "ocr":
      return await processOCRResult(
        result as OCROacJsonResponse,
        hasValidMetadata,
      );
    case "layout-analysis":
      return await processLAResult(
        result as LAOacJsonResponse,
        hasValidMetadata,
      );
    default:
      return result;
  }
};

// 결과를 파일 목록에 추가
export const addResultToFiles = async (
  result: OacJsonResponse,
  filename: string,
  selectedModelIndex: number,
  inferenceConfig: any,
  endpointType: EndpointType,
  newResults: OacJsonResponse[],
  newFiles: ResultFile[],
) => {
  if (!result) return;

  const processedResult = await getProcessedResult(result, endpointType);

  newResults.push(processedResult);

  newFiles.push({
    id: uuidv4(),
    title: filename,
    result: processedResult,
    modelIndex: selectedModelIndex,
    inferenceConfig: inferenceConfig,
  });
};
